<!-- 我的信息 -->
<template>
    <div class="content">
        <Form :model="formData" label-position="right" :label-width="130">
            <FormItem label="账号名称：">
                <div>{{ formData.platform_name }}</div>
            </FormItem>
            <FormItem label="账号logo：">
                <img
                    class="wh80"
                    v-if="formData.show_platform_logo"
                    :src="formData.show_platform_logo"
                />
            </FormItem>
            <FormItem label="联系人：">
                <div>{{ formData.contact }}</div>
            </FormItem>
            <FormItem label="手机号：">
                <div>{{ formData.mobile }}</div>
            </FormItem>
            <FormItem label="我的账号：">
                <div>{{ formData.account }}</div>
            </FormItem>
            <FormItem label="创建二维码数量：">
                <div>
                    {{ formData.qrcode_count ? formData.qrcode_count : "无限" }}
                </div>
            </FormItem>
            <FormItem label="过期时间：">
                <div>{{ formData.expire_time }}</div>
            </FormItem>
        </Form>
        <div class="footer-btn">
            <Button class="theme-bc" type="warning" @click="goModal"
                >修改</Button
            >
        </div>
        <!-- 修改信息 -->
        <Modal
            v-model="modals"
            title="修改信息"
            width="500"
            :mask-closable="false"
        >
            <Form :model="formItem" label-position="right" :label-width="130">
                <FormItem label="账号名称：">
                    <Input
                        class="w200"
                        v-model="formItem.platform_name"
                        type="text"
                        placeholder="请输入账号名称"
                    ></Input>
                </FormItem>
                <FormItem label="账号logo：">
                    <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :format="['jpg', 'jpeg', 'png', 'gif']"
                        :max-size="2048"
                        :on-progress="handleProgress"
                        :on-format-error="handleFormatError"
                        :on-success="logoSuccess"
                        :headers="headers"
                        :action="uploadImg"
                    >
                        <div class="form-upload">
                            <img
                                class="wh100"
                                v-if="formData.show_platform_logo"
                                :src="formData.show_platform_logo"
                            />
                            <Icon
                                v-else
                                type="ios-add"
                                size="40"
                                color="#AEAEB3"
                            />
                        </div>
                    </Upload>
                </FormItem>
                <FormItem label="联系人：">
                    <Input
                        class="w200"
                        v-model="formItem.contact"
                        type="text"
                        placeholder="请输入联系人"
                    ></Input>
                </FormItem>
                <FormItem label="手机号：">
                    <Input
                        class="w200"
                        v-model="formItem.mobile"
                        type="number"
                        placeholder="请输入手机号"
                    ></Input>
                </FormItem>
                <FormItem label="我的账号：">
                    <Input
                        class="w200"
                        v-model="formItem.account"
                        type="text"
                        placeholder="请输入我的账号"
                    ></Input>
                </FormItem>
                <FormItem label="密码：">
                    <Input
                        class="w200"
                        v-model="formItem.password"
                        type="password"
                        password
                        placeholder="请输入密码"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import { plat_info_index, plat_info_modify } from "@/api/index";
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
import { removeCookies } from "@/utils/helper";
export default {
    data() {
        return {
            uploadImg: config.apiUrl + "/plat/other/upload",
            headers: { "hlzw-plat-suyuan-token": getCookies("platToken") },
            formData: {
                platform_name: "",
                show_platform_logo: "",
                contact: "",
                mobile: "",
                account: "",
                qrcode_count: "",
                expire_time: "",
            },
            formItem: {
                account: "",
                password: "",
                platform_name: "",
                platform_logo: "",
                contact: "",
                mobile: "",
            },
            modals: false,
        };
    },
    mounted() {
        this.getPlatInfoIndex();
    },
    methods: {
        getPlatInfoIndex() {
            plat_info_index().then((res) => {
                this.formData.platform_name = res.data.info.platform_name;
                this.formData.show_platform_logo =
                    res.data.info.show_platform_logo;
                this.formData.contact = res.data.info.contact;
                this.formData.mobile = res.data.info.mobile;
                this.formData.account = res.data.account;
                this.formData.qrcode_count = res.data.info.qrcode_count;
                this.formData.expire_time = res.data.expire_time;
                this.formItem.account = res.data.account;
                this.formItem.platform_name = res.data.info.platform_name;
                this.formItem.platform_logo = res.data.info.platform_logo;
                this.formItem.contact = res.data.info.contact;
                this.formItem.mobile = res.data.info.mobile;
            });
        },
        goModal() {
            this.modals = true;
        },
        // 确定
        submitModal() {
            plat_info_modify(this.formItem)
                .then((res) => {
                    this.getPlatInfoIndex();
                    this.modals = false;
                    this.$Message.success(res.msg);
                    removeCookies("platToken");
                    localStorage.clear();
                    this.$router.push({ path: "/" });
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        // 文件上传时
        handleProgress() {
            this.$Message.loading({
                content: "上传中...",
                duration: 0,
            });
        },
        // 文件上传类型错误
        handleFormatError() {
            this.$Message.destroy();
            this.$Message.warning("暂不支持上传此格式");
        },
        // 平台logo图片上传成功
        logoSuccess(e) {
            this.formItem.platform_logo = e.data.url;
            this.formData.show_platform_logo = e.data.path;
            this.$Message.destroy();
            this.$Message.success(e.msg);
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.wh80 {
    width: 80px;
    height: 80px;
    border-radius: 4px;
}
.form-upload {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 4px;
    border: 1px solid #ccc;
    cursor: pointer;
}
.wh100 {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.footer-btn {
    margin-top: 24px;
    text-align: right;
}
</style>